import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from './ProtectedRoute';

const Dashboard = Loadable(lazy(() => import('pages/gym/Dashboard')));
const Analysis = Loadable(lazy(() => import('pages/gym/Analysis')));
const Members = Loadable(lazy(() => import('pages/member/Members')));
const MemberDetails = Loadable(lazy(() => import('pages/member/MemberDetails')));
const MemberActivity = Loadable(lazy(() => import('pages/member/MemberActivity')));
const MembershipRequest = Loadable(lazy(() => import('pages/memberRequest/MembershipRequest')));
const Trainers = Loadable(lazy(() => import('pages/trainer/Trainers')));
const AddTrainer = Loadable(lazy(() => import('pages/trainer/AddTrainer')));
const EditTrainer = Loadable(lazy(() => import('pages/trainer/EditTrainer')));
const Specialization = Loadable(lazy(() => import('pages/master/specialization/Specialization')));
const Profile = Loadable(lazy(() => import('pages/profile/Profile')));
const Login = Loadable(lazy(() => import('pages/auth/Login')));
const Register = Loadable(lazy(() => import('pages/auth/Register')));
const NotFound = Loadable(lazy(() => import('components/NotFound')));

const MainRoutes = {
  path: '/',
  children: [
    { path: 'login', element: <Login /> },
    { path: 'register', element: <Register /> },
    {
      element: (
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      ),
      children: [
        { index: true, element: <Navigate to="/dashboard" replace /> },
        { path: 'dashboard', element: <Dashboard /> },
        { path: 'analysis', element: <Analysis /> },
        { path: 'membership-request', element: <MembershipRequest /> },
        { path: 'members', element: <Members /> },
        { path: 'members/:id', element: <MemberDetails /> },
        { path: 'members/:id/activity', element: <MemberActivity /> },
        { path: 'trainers', element: <Trainers /> },
        { path: 'trainer/add', element: <AddTrainer /> },
        { path: 'trainer/edit/:id', element: <EditTrainer /> },
        { path: 'specializations', element: <Specialization /> },
        { path: 'profile', element: <Profile /> },

        { path: '*', element: <NotFound /> }
      ]
    }
  ]
};

export default MainRoutes;
